(function (window, document) {
  'use strict';

  if (window.__BDConsentPreflightV144) return;
  window.__BDConsentPreflightV144 = true;

  var VERSION = '1.4.4';
  var STORAGE_KEY = 'bd_cookie_consent_v2';
  var LEGACY_KEY = 'bd_cookie_consent_v1';
  var RELOAD_KEY = 'bd_consent_reload_v144';
  var blockedCount = 0;

  function safeParse(value) {
    if (!value) return null;
    try {
      var parsed = JSON.parse(value);
      if (parsed && typeof parsed === 'object') return parsed;
    } catch (_) {}
    if (value === 'all') return { analytics: true, marketing: true, preferences: true };
    if (value === 'essential') return { analytics: false, marketing: false, preferences: false };
    return null;
  }

  function readChoice() {
    try {
      return safeParse(window.localStorage.getItem(STORAGE_KEY)) || safeParse(window.localStorage.getItem(LEGACY_KEY));
    } catch (_) {
      return null;
    }
  }

  function normalize(value) {
    return {
      analytics: Boolean(value && value.analytics),
      marketing: Boolean(value && value.marketing),
      preferences: Boolean(value && value.preferences)
    };
  }

  var state = normalize(readChoice());

  window.dataLayer = window.dataLayer || [];
  var gtag = typeof window.gtag === 'function' ? window.gtag : function () {
    window.dataLayer.push(arguments);
  };
  if (typeof window.gtag !== 'function') window.gtag = gtag;

  function applyGoogleConsent(mode) {
    try {
      gtag('consent', mode, {
        ad_storage: state.marketing ? 'granted' : 'denied',
        analytics_storage: state.analytics ? 'granted' : 'denied',
        ad_user_data: state.marketing ? 'granted' : 'denied',
        ad_personalization: state.marketing ? 'granted' : 'denied',
        functionality_storage: state.preferences ? 'granted' : 'denied',
        personalization_storage: state.preferences ? 'granted' : 'denied',
        security_storage: 'granted',
        wait_for_update: 800
      });
      gtag('set', 'ads_data_redaction', true);
      gtag('set', 'url_passthrough', false);
    } catch (_) {}
  }

  applyGoogleConsent('default');

  function purposeAllowed(purpose) {
    if (purpose === 'marketing') return state.marketing;
    if (purpose === 'analytics') return state.analytics;
    if (purpose === 'preferences') return state.preferences;
    return true;
  }

  function classifyCookie(name) {
    var key = String(name || '').trim();
    if (/^(_ga($|_)|_gid$|_gat($|_)|_gac_)/i.test(key)) return 'analytics';
    if (/^(_gcl_|_fbp$|_fbc$|_ttp$|_tt_enable_cookie$|_pin_unauth$|_clck$|_clsk$|IDE$|ANID$|NID$)/i.test(key)) return 'marketing';
    return null;
  }

  function classifyUrl(raw) {
    if (!raw) return null;
    var url;
    try { url = new URL(String(raw), window.location.href); } catch (_) { return null; }
    var host = String(url.hostname || '').toLowerCase();
    var path = String(url.pathname || '').toLowerCase();

    if (host.indexOf('google-analytics.com') !== -1 || host.indexOf('analytics.google.com') !== -1) return 'analytics';
    if (host.indexOf('googletagmanager.com') !== -1 && (path.indexOf('/gtag/') !== -1 || path.indexOf('/gtm.js') !== -1 || path.indexOf('/ns.html') !== -1)) return 'marketing';
    if (host.indexOf('googleadservices.com') !== -1 || host.indexOf('doubleclick.net') !== -1 || host.indexOf('googlesyndication.com') !== -1) return 'marketing';
    if (host.indexOf('connect.facebook.net') !== -1 || host.indexOf('facebook.com') !== -1 && path.indexOf('/tr') !== -1) return 'marketing';
    if (host.indexOf('tiktok.com') !== -1 || host.indexOf('analytics.tiktok.com') !== -1) return 'marketing';
    if (host.indexOf('pinterest.com') !== -1 || host.indexOf('pinimg.com') !== -1) return 'marketing';
    if (host.indexOf('hotjar.com') !== -1 || host.indexOf('clarity.ms') !== -1 || host.indexOf('clarity.microsoft.com') !== -1) return 'analytics';
    return null;
  }

  function recordBlock(kind, target, purpose) {
    blockedCount += 1;
    window.__BDConsentPreflightState = {
      version: VERSION,
      analytics: state.analytics,
      marketing: state.marketing,
      preferences: state.preferences,
      blockedCount: blockedCount,
      lastBlockedKind: kind,
      lastBlockedPurpose: purpose,
      lastBlockedTarget: String(target || '').slice(0, 240)
    };
  }

  function findCookieDescriptor() {
    var proto = document;
    while (proto) {
      var descriptor;
      try { descriptor = Object.getOwnPropertyDescriptor(proto, 'cookie'); } catch (_) {}
      if (descriptor && descriptor.get && descriptor.set) return descriptor;
      proto = Object.getPrototypeOf(proto);
    }
    return null;
  }

  var cookieDescriptor = findCookieDescriptor();
  var nativeCookieSet = cookieDescriptor && cookieDescriptor.set;
  var nativeCookieGet = cookieDescriptor && cookieDescriptor.get;

  function expireCookie(name) {
    if (!nativeCookieSet || !name) return;
    var values = [
      name + '=; Max-Age=0; path=/; SameSite=Lax',
      name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'
    ];
    var host = String(window.location.hostname || '');
    if (host) {
      values.push(name + '=; Max-Age=0; path=/; domain=' + host);
      values.push(name + '=; Max-Age=0; path=/; domain=.' + host.replace(/^www\./, ''));
    }
    values.forEach(function (value) {
      try { nativeCookieSet.call(document, value); } catch (_) {}
    });
  }

  function clearOptionalCookies() {
    if (!nativeCookieGet) return;
    var raw = '';
    try { raw = nativeCookieGet.call(document) || ''; } catch (_) {}
    raw.split(';').forEach(function (entry) {
      var name = entry.split('=')[0].trim();
      var purpose = classifyCookie(name);
      if (purpose && !purposeAllowed(purpose)) expireCookie(name);
    });
  }

  if (cookieDescriptor && nativeCookieSet && nativeCookieGet) {
    clearOptionalCookies();
    try {
      Object.defineProperty(document, 'cookie', {
        configurable: true,
        enumerable: cookieDescriptor.enumerable,
        get: function () { return nativeCookieGet.call(document); },
        set: function (value) {
          var name = String(value || '').split('=')[0].trim();
          var purpose = classifyCookie(name);
          if (purpose && !purposeAllowed(purpose)) {
            recordBlock('cookie', name, purpose);
            return value;
          }
          return nativeCookieSet.call(document, value);
        }
      });
    } catch (_) {}
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var target = typeof input === 'string' ? input : input && input.url;
      var purpose = classifyUrl(target);
      if (purpose && !purposeAllowed(purpose)) {
        recordBlock('fetch', target, purpose);
        if (typeof Response === 'function') return Promise.resolve(new Response(null, { status: 204, statusText: 'Consent blocked' }));
        return Promise.resolve({ ok: true, status: 204, text: function () { return Promise.resolve(''); }, json: function () { return Promise.resolve({}); } });
      }
      return nativeFetch.apply(this, arguments);
    };
  }

  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
    var nativeOpen = window.XMLHttpRequest.prototype.open;
    var nativeSend = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__bdConsentTarget = url;
      this.__bdConsentPurpose = classifyUrl(url);
      return nativeOpen.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function () {
      if (this.__bdConsentPurpose && !purposeAllowed(this.__bdConsentPurpose)) {
        recordBlock('xhr', this.__bdConsentTarget, this.__bdConsentPurpose);
        try { this.abort(); } catch (_) {}
        return;
      }
      return nativeSend.apply(this, arguments);
    };
  }

  if (navigator && typeof navigator.sendBeacon === 'function') {
    var nativeBeacon = navigator.sendBeacon.bind(navigator);
    navigator.sendBeacon = function (url, data) {
      var purpose = classifyUrl(url);
      if (purpose && !purposeAllowed(purpose)) {
        recordBlock('beacon', url, purpose);
        return true;
      }
      return nativeBeacon(url, data);
    };
  }

  function nodeTarget(node) {
    if (!node || !node.tagName) return null;
    var tag = String(node.tagName).toUpperCase();
    if (tag === 'SCRIPT' || tag === 'IMG' || tag === 'IFRAME') return node.src || node.getAttribute && node.getAttribute('src');
    if (tag === 'LINK') return node.href || node.getAttribute && node.getAttribute('href');
    return null;
  }

  function shouldBlockNode(node) {
    var target = nodeTarget(node);
    var purpose = classifyUrl(target);
    if (purpose && !purposeAllowed(purpose)) {
      recordBlock('node', target, purpose);
      return true;
    }
    return false;
  }

  var nativeAppendChild = Node.prototype.appendChild;
  var nativeInsertBefore = Node.prototype.insertBefore;
  Node.prototype.appendChild = function (node) {
    if (shouldBlockNode(node)) return node;
    return nativeAppendChild.call(this, node);
  };
  Node.prototype.insertBefore = function (node, reference) {
    if (shouldBlockNode(node)) return node;
    return nativeInsertBefore.call(this, node, reference);
  };

  function update(next) {
    var previous = state;
    state = normalize(next || readChoice());
    applyGoogleConsent('update');
    clearOptionalCookies();
    window.__BDConsentPreflightState = {
      version: VERSION,
      analytics: state.analytics,
      marketing: state.marketing,
      preferences: state.preferences,
      blockedCount: blockedCount
    };

    var newlyAllowed = (!previous.analytics && state.analytics) || (!previous.marketing && state.marketing) || (!previous.preferences && state.preferences);
    if (newlyAllowed && blockedCount > 0) {
      try {
        var signature = JSON.stringify(state);
        if (window.sessionStorage.getItem(RELOAD_KEY) !== signature) {
          window.sessionStorage.setItem(RELOAD_KEY, signature);
          window.location.reload();
        }
      } catch (_) {}
    }
  }

  document.addEventListener('bd:consent-changed', function (event) {
    update(event && event.detail && event.detail.choice);
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY || event.key === LEGACY_KEY) update(readChoice());
  });

  document.documentElement.dataset.bdConsentPreflight = VERSION;
  window.__BDConsentPreflightState = {
    version: VERSION,
    analytics: state.analytics,
    marketing: state.marketing,
    preferences: state.preferences,
    blockedCount: blockedCount
  };
})(window, document);
